import type { StateDeclarationFn } from 'controller/types';
import type { IApplicationUser } from 'store/application';
import type { ICentralFeedListResponse } from '@wix/social-groups-serverless/dist/central-feed/types';

export default (function (vm, store, params) {
  const { isMobile } = params.flowAPI.environment;

  return {
    name: 'my-groups.posts',
    url: '/posts',
    data: {
      title: 'my-groups.posts',
      sectionId: 'my-groups',
    },
    resolve: [
      {
        token: 'feed',
        deps: ['user'],
        resolveFn(user: IApplicationUser) {
          if (user.memberId) {
            return vm.centralFeed$.fetchByAuthor(user.memberId);
          }
        },
      },
      {
        token: 'comments',
        deps: ['feed'],
        async resolveFn(feed?: ICentralFeedListResponse) {
          if (isMobile) {
            return;
          }
          return vm._.comments.fetch(feed?.items);
        },
      },
    ],
  };
} as StateDeclarationFn);
